import createHistory from 'history/createBrowserHistory'
import * as React from 'react'
import { hydrate } from 'react-dom'
import { AppContainer } from 'react-hot-loader'

import {
  clientFinishedLoading,
  setExperimentalMenuConfig
} from '../../common/actions/common'

import { hasFeature } from '../../common/utils/features'

import configureStore from '../../common/store/configureStore'
import legacyAffiliates from '../../common/utils/legacyAffiliates'
import App from './app'

import '../../assets/stylesheets/style.css'
import './index.css'

const history = createHistory()

// this only runs on initial hydrating
const initialState = (window as any).INITIAL_STATE
delete (window as any).INITIAL_STATE

const store = configureStore(initialState, history)

const { currentSite } = store.getState().common
const { location } = store.getState().router

legacyAffiliates(window.location)

hydrate(
  <AppContainer>
    <App store={store} history={history} />
  </AppContainer>,
  document.querySelector('#react-view'),
  () => {
    store.dispatch(clientFinishedLoading())

    const { experiments } = store.getState()

    if (hasFeature('salePage', currentSite, location, experiments)) {
      store.dispatch(setExperimentalMenuConfig(currentSite))
    }
  }
)

if (module.hot) {
  module.hot.accept('./app', () => {
    const NewApp = require('./app').default
    hydrate(
      <AppContainer>
        <NewApp store={store} history={history} />
      </AppContainer>,
      document.querySelector('#react-view')
    )
  })
}
